<template>
    <button class="button is-primary is-light has-fullwidth mu-font no-border-radius-bottom" @click="buttonAction()">
      JUGADORES ONLINE |&nbsp;<b>{{accounts}}</b>&nbsp;|
    </button>
</template>

<script>
export default {
    name: 'OnlineHomeSection',
    computed: {
        accounts() {
            return this.$store.getters.GetMemberStatus
        }
    },
    methods: {
        buttonAction() {
            this.accounts > 0 ? 
                this.$store.commit('openOnlineModal') :
                this.$toasted.show('No hay jugadores activos en estos momentos.', { 
                        position: "top-center", 
                        duration : 5000
                    });
        }
        
    }
}
</script>

<style>

</style>